import {
  MESSAGES_OUTBOX_TAB_LOAD_DATA,
  MESSAGES_OUTBOX_TAB_LOAD_DATA_RESULT
} from 'Redux/actionTypes';

export const messagesOutboxTabGetData = (deviceId, filters, nextToken) => ({
  type: MESSAGES_OUTBOX_TAB_LOAD_DATA,
  payload: { deviceId, filters, nextToken }
});

export const messagesOutboxTabGetDataResult = (data) => ({
  type: MESSAGES_OUTBOX_TAB_LOAD_DATA_RESULT,
  payload: data
});